import { clone } from './clone';
import { matches } from './matches';
export function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    let i;
    let patternLength;
    for (i = 0; i < cardConfiguration.patterns.length; i++) {
        const pattern = cardConfiguration.patterns[i];
        if (!matches(cardNumber, pattern)) {
            // eslint-disable-next-line no-continue
            continue;
        }
        const clonedCardConfiguration = clone(cardConfiguration);
        if (Array.isArray(pattern)) {
            patternLength = String(pattern[0]).length;
        }
        else {
            patternLength = String(pattern).length;
        }
        if (cardNumber.length >= patternLength) {
            clonedCardConfiguration.matchStrength = patternLength;
        }
        results.push(clonedCardConfiguration);
        break;
    }
}
//# sourceMappingURL=add-matching-cards-to-results.js.map